import { render, staticRenderFns } from "./DlgGuestDelete.vue?vue&type=template&id=678123da&scoped=true"
import script from "./DlgGuestDelete.vue?vue&type=script&lang=ts"
export * from "./DlgGuestDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678123da",
  null
  
)

export default component.exports